var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"ml-1 text-red-500"},[_vm._v("*")])
}
var staticRenderFns = []

export { render, staticRenderFns }